import { PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});

export default function QueryProvider({children}: PropsWithChildren){
    return <QueryClientProvider client={queryClient}>
        {children}
        </QueryClientProvider>;
}